module.exports = __webpack_public_path__ + "img/text_2.c5d921b6.png";